
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  PhotosApi,
  Workorder,
  PhotographPagedCollectionApiResponse,
  Photograph
} from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    photosApi: 'photosApi'
  })
})
export default class PhotoCarousel extends Vue {
  @Prop({ required: true })
  private order!: Workorder;

  private photosApi!: PhotosApi;

  private photoSource(photo: Photograph) {
    if (!photo) return null;
    if (!photo.photo) return null;
    if (photo.photo.length <= 0) return null;
    return window.URL.createObjectURL(photo.photo);
  }

  private loading = true;

  private photos!: PhotographPagedCollectionApiResponse;

  data() {
    return {
      photos: undefined
    };
  }

  async mounted() {
    await this.loadPhotos();
  }

  @Watch('order', { deep: true })
  async loadPhotos() {
    this.loading = true;
    this.photos = await this.photosApi.queryPhotos({
      workorderId: this.order.workorderId?.toString(),
      includeContainerData: true
    });
    this.loading = false;
  }
}
